import { Box, Text } from "@chakra-ui/react";

export default function LabelItem({ title, value }: { title: string; value: string }) {

    return (
        <Box mr={16}>
            <Text fontSize={12}>
                {title}
            </Text>

            <Text>
                {value}
            </Text>
        </Box>
    )
}